import React, { memo, useCallback } from 'react';
import { SelectOption } from '@leasequery/lq.react-component-library';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';
import { ReportType, ClientCustomCalendarModel } from '../../../../models';
import ReportSettingPIT from '../ReportSettingPIT';

interface ReportSettingPAndLProps {
  onChange: (updatedValue: ReportSettingPAndLState) => void;
  reportSettingState: ReportSettingPAndLState;
  reportTypeSetting: ReportTypeSetting;
  customCalendarSettings?: ClientCustomCalendarModel;
  isAllowPIT: boolean;
}

export interface ReportSettingPAndLState {
  selectedViewBy: SelectOption<string>;
  selectedSubViewBy?: SelectOption<string>;
  isValid: boolean;
}

function ReportDateSettingPAndL({
  onChange,
  reportSettingState,
  reportTypeSetting,
  isAllowPIT,
  customCalendarSettings,
}: ReportSettingPAndLProps): JSX.Element {
  return (
    <>
      <ReportSettingPIT
        reportType={ReportType.effectOfStandardAdoptionPAndL}
        reportSettingState={reportSettingState}
        reportTypeSetting={reportTypeSetting}
        customCalendarSettings={customCalendarSettings}
        isAllowPIT={isAllowPIT}
        onChange={useCallback(
          (state) => onChange(state as ReportSettingPAndLState),
          [onChange],
        )}
      />
    </>
  );
}

export default memo(ReportDateSettingPAndL);
